<template>
  <div class="container-pedidos">
    <div class="coluna-1">
      <div class="d-md-none mb-2">
        <button class="btn btn-secondary btn-block" @click="$refs.manual.openPedidoManual()">
          <i class="fa fa-plus mr-1"></i> Novo Pedido
        </button>
      </div>
      <div class="mb-2" v-show="pesquisa.page === 0">
        <pesquisar-pedido @pesquisar="filtrar" :load="loadPedidos"/>
      </div>
      <div class="row no-gutters mb-2 align-items-center" v-if="pesquisa.page > 0">
        <div class="col-6 pr-1">
          <button class="btn btn-outline-dark" @click="clearPesquisa()"><i class="fa fa-angle-left"></i> Voltar</button>
        </div>
        <div class="col-6 pl-1 text-right small">
          Página: {{pesquisa.page + 1}}
        </div>
      </div>
      <div class="coluna-1-1 rounded">
        <span id="topo"></span>
        <div class="p-2 border-bottom small d-flex align-items-center bg-white pointer" v-if="ifood && !ifoodAtivo" @click="msgIfood()">
          <i class="fa fa-info-circle mr-2"></i>
          <div class="mr-auto">iFood sincronizado no Gestor Principal</div>
        </div>
        <div class="p-2 bg-warning text-white small" v-if="pesquisa.ativada">
          <div class="d-flex align-items-center">
            <i class="fa fa-filter ml-1 mr-2"></i>
            <div>Filtro de pesquisa ativado<div v-if="bell.status">Pedidos na fila de espera: {{ bell.orders }}</div></div>
            <div class="ml-auto text-nowrap"><a href="javascript:" @click="clearPesquisa()" class="text-white"><u>Limpar pesquisa</u></a></div>
          </div>
        </div>
        <div class="bg-white text-center p-2 border-bottom" v-if="pilotoAutomatico && !isRead">
          <i class="fa fa-robot"></i>
          <div class="font-weight-bold">Modo Piloto Automático</div>
          <p class="mb-0 small">
            <span v-if="paLoad">Pedidos na fila => {{ paLoad }}</span>
            <span v-else>Os pedidos serão aceitos automaticamente</span>
          </p>
        </div>
        <loading style="padding-top: 48px" v-if="loadPedidos"/>
        <div class="bg-white" v-show="!loadPedidos">
          <div class="border-bottom p-2" v-for="(p, i) in pedidos" :key="i" :class="{'bg-selecionado' : selecionado.id_pedido === p.id_pedido}">
            <a href="javascript:" :id="'listPedido' + p.id_pedido" class="text-decoration-none text-dark" @click="abrirPedido(p)">
              <div class="list-pedido">
                <div>
                  <h6 class="mb-0">#{{p.id_comanda || p.id_contador}} - {{p.nome_cliente}}</h6>
                  <div class="mb-0 small">
                    {{p.data_pedido}}
                  </div>
                  <div class="font-weight-bold">
                    <span class="badge badge-warning mr-1" v-if="p.origin === '4'">QR Code</span>
                    <span class="badge badge-success mr-1" v-else-if="p.tipo_pedido === '1'">Entregar</span>
                    <span class="badge badge-info mr-1" v-else-if="p.tipo_pedido === '2'">Retirar</span>
                    <img src="../../assets/icons/ifood.svg" class="mt-1" title="Pedido realizado via iFood" style="width: 30px" v-if="p.origin === '6'">
                    <img src="../../assets/icons/uairango.svg" title="Pedido realizado via UaiRango" class="mt-2" style="width: 30px" v-else-if="p.origin === '7'">
                    <span class="badge border border-dark" title="Pedido realizado no App ou Site" v-else-if="p.origin === '1'">App/Site</span>
                    <span class="badge border border-dark" title="Pedido realizado via App LeCard" v-else-if="p.origin === '2'">Geral</span>
                    <span class="badge border border-dark" title="Pedido realizado via Pedido Manual" v-else-if="p.origin === '3'">Manual</span>
                    <span class="badge border border-dark" title="Pedido realizado via Qr Code no local" v-else-if="p.origin === '4'">Qr Code</span>
                    <span v-else-if="p.origin === '5'" class="badge badge-success px-4" title="Pedido realizado via WhatsApp"><span class="icon-whatsapp"></span></span>
                  </div>
                </div>
                <div class="text-right">
                  <span class="badge badge-danger" v-if="p.status === '1'">Aguardando</span>
                  <span class="badge badge-info" v-if="p.status === '2'">Preparando</span>
                  <span class="badge badge-dark" v-if="p.origin !== '4' && p.status === '3'">Despachado</span>
                  <span class="badge text-dark" v-if="p.status === '4'">Finalizado</span>
                  <div v-else-if="p.data_agendamento && p.status <= 3"><span class="badge badge-warning">Agendado</span></div>
                  <div v-else-if="p.status === '5'"><span class="badge text-danger border border-danger">Cancelado</span></div>
                  <img src="../../assets/icons/ifood.svg" class="mr-2 d-block ml-auto mt-3" style="width: 32px" v-if="p.origin === '6'">
                  <img src="../../assets/icons/uairango.svg" class="mr-2 d-block ml-auto mt-3" style="width: 32px" v-if="p.origin === '7'">
                </div>
              </div>
              <div class="list-pedido-footer" v-if="multiple">{{ p.nome_fantasia }}</div>
            </a>
            <div class="text-center border-top pt-1 mt-2" v-if="p.tipo_pedido === '1'">
              <a href="javascript:" class="text-success" v-if="p.id_entregador" @click="escolherEntregador(p)">
                <img src="../../assets/icons/helmet.svg" title="Entregador" class="mr-1"> {{p.nome_entregador}}
              </a>
              <a href="javascript:" title="Adicionar entregador" class="btn btn-sm text-success" @click="escolherEntregador(p)"
                 v-else-if="p.status < 5 && user.entregadores">
                <i class="fa fa-plus mr-1"></i> Adicionar entregador
              </a>
            </div>
          </div>
        </div>
        <div class="px-2 py-3 d-flex justify-content-between" v-if="!loadPedidos && (pesquisa.page > 0 || pedidos.length === this.pagination)">
          <button class="btn btn-sm text-primary" @click="paginarPedidos(-1)" :disabled="pesquisa.page === 0"><i class="fa fa-angle-left"></i> Anterior</button>
          <button class="btn btn-sm text-primary" @click="paginarPedidos(1)" :disabled="pedidos.length < this.pagination">Próxima <i class="fa fa-angle-right"></i></button>
        </div>
      </div>
      <div class="container-aceitar container-resumo bg-light">
        <div class="card p-2 small pointer" @click="visualizarResumo()">
          <div class="d-flex justify-content-between align-items-center" v-show="loadPedidos">
            <div>
              <div class="m-0 text-muted">Nesta lista: <b>{{pedidos.length}} pedido{{pedidos.length === 1 ? '' : 's'}}</b></div>
              <div class="text-muted">Ver resumo completo</div>
            </div>
            <div>
              <button class="btn btn-dark btn-sm px-2" title="Imprimir Resumo dos Pedidos" :disabled="paLoad > 0">
                <i class="fa fa-chart-line mr-1"></i> Resumo <span class="d-none d-sm-inline-block">diário</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="coluna-2" :class="{'aberto': aberto}">
      <div class="mr-2 d-none d-md-flex justify-content-between">
        <a class="border py-1 px-2 rounded-sm mr-2 text-dark text-decoration-none d-none d-md-block text-nowrap" href="javascript:"
           @click="togglePilotoAutomatico" title="Habilite para aceitar os pedidos automaticamente" v-if="printServer && !isRead">
          <span class="pr-1 font-weight-bold" style="font-size: 11px">Piloto automático</span>
          <img class="switch" src="../../assets/icons/switch-on.svg" v-show="pilotoAutomatico"/>
          <img class="switch" src="../../assets/icons/switch-off.svg" v-show="!pilotoAutomatico"/>
        </a>
        <div class="ml-auto">
          <button class="btn btn-outline-primary mr-2" v-if="bell && bell.status" @click="pausarNotificacao()">
            <i class="fa fa-pause-circle mr-1"></i> Pausar som
          </button>
          <button v-if="!modal" class="btn btn-secondary" @click="$refs.manual.openPedidoManual()">
            <i class="fa fa-plus mr-1"></i> Pedido manual
          </button>
          <button class="btn btn-outline-dark ml-2" @click="$emit('fecharModal')" v-if="modal">
            Fechar <i class="fa fa-times ml-1"></i>
          </button>
        </div>
      </div>
      <div class="conteudo-c2 rounded">
        <loading style="padding-top: 28vh" v-show="loading"/>
        <div v-show="!loading">
          <div class="border-bottom d-md-none p-2 mb-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <a href="javascript:" class="btn btn-outline-dark" @click="clearPedido(true)"><i class="fa fa-chevron-left mr-1"></i></a>
              </div>
              <div v-show="!loading">
                <a href="javascript:" class="btn btn-primary" @click="imprimir(1)"><i class="fa fa-print"></i></a>
              </div>
            </div>
          </div>
          <div class="container-produtos">
            <cupom-delivery :selecionado="selecionado"
              @modalIntegracao="openModalIntegracao"
              @toggleCliente="toggleCliente"
              @escolherEntregador="escolherEntregador"
              @openModalPagamento="openModalPagamento"
            />
            <msg-home class="mt-1" :hide="selecionado.cliente"/>
          </div>
        </div>
      </div>
      <div class="container-aceitar">
        <div class="card p-2">
          <div class="d-flex justify-content-between">
            <div class="btn-imprimir mr-2">
              <button class="btn btn-outline-dark btn-block" :disabled="paLoad > 0" @click="prepararImpressao()" :class="{'visibility':!selecionado.status}">
                Imprimir
              </button>
            </div>
            <div class="btn-cancelar mr-2" v-show="['1','2','3'].includes(selecionado.status)">
              <button :disabled="loading || paLoad > 0" class="btn btn-secondary btn-block" @click="openModalCancelamento">{{selecionado.status === '1' ? 'Recusar' : 'Cancelar'}}</button>
            </div>
            <div class="btn-aceitar ml-auto" v-if="selecionado.status === '1'">
              <button class="btn btn-success btn-block" @click="acaoPedido(2)" :disabled="loading || paLoad > 0">Aceitar</button>
            </div>
            <div class="btn-aceitar ml-auto" v-if="selecionado.status === '2'">
              <button class="btn btn-dark btn-block" @click="escolherEntregador(selecionado, true)" :disabled="loading || paLoad > 0">Despachar</button>
            </div>
            <div class="btn-aceitar ml-auto" v-if="selecionado.status === '3'">
              <button class="btn btn-info btn-block" @click="acaoPedido(4)" :disabled="loading || paLoad > 0">Finalizar</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal width="tiny" :opened="modalCancelamento">
      <div v-if="loadModal" class="py-5">
        <loading text="Buscando cancelamentos disponíveis"/>
      </div>
      <div v-else>
        <div class="mb-2">
          <label for="motivoCancelamento" class="small mb-0"><b>Motivo do cancelamento*</b></label>
          <select id="motivoCancelamento" class="form-control" style="max-width: 300px" v-model="cancelamento.tipo_cancelamento" @change="changeCancelamento">
            <option :value="null">Selecione um motivo</option>
            <option v-for="r in motivos" :key="r.tipo_cancelamento" :value="r.tipo_cancelamento">{{r.obs_cancelamento}}</option>
          </select>
        </div>
        <div>
          <label class="small mb-0"><b>Observação adicional<span v-if="cancelamento.requer_observacao">*</span></b></label>
          <textarea id="textCancelamento" v-model="cancelamento.obs_cancelamento" :disabled="!cancelamento.requer_observacao" class="form-control mb-4" placeholder="Informe o motivo para recusar este pedido" rows="5" style="resize: none"></textarea>
        </div>
      </div>
      <div class="container-fluid p-0">
        <div class="row no-gutters">
          <div class="col-6 pr-1">
            <button class="btn btn-dark btn-block rounded-sm" @click="modalCancelamento = false">Voltar</button>
          </div>
          <div class="col-6 pl-1">
            <button :disabled="!podeConfirmarCancelamento" class="btn btn-secondary btn-block rounded-sm" @click="cancelarPedido()"><b>Confirmar</b></button>
          </div>
        </div>
      </div>
    </modal>

    <modal :opened="modalPagamento">
      <div v-if="modalPagamento === 1">
        <h6 class="pointer text-center border-bottom pb-3 mb-0">Histórico de Pagamentos</h6>
        <div class="table-responsive" v-if="pagamentos && pagamentos.length">
          <table class="table border rounded-sm small my-2">
            <tr class="bg-light">
              <th>Pagamento</th>
              <th>Status</th>
              <th>&nbsp;</th>
            </tr>
            <tr v-for="p in pagamentos">
              <td class="text-nowrap">{{p.created_at}}</td>
              <td>
                LeCard: {{p.status_lecard | status}} <br>
                Getway: {{p.status}}
              </td>
              <td>                
                <a v-if="p.plataforma == 1" :href="`https://www.mercadopago.com.br/activities/1?q=${p.codigo_externo}`" target="_blank">Visualizar</a>
                <a v-else-if="p.plataforma == 5" :href="`https://dash.pagar.me/`" target="_blank">Visualizar</a>
              </td>
            </tr>
          </table>
        </div>
        <div class="my-5 text-center" v-else>
          <p class="mb-0">{{loadModal ? 'Carregando dados..' : 'Não foi encontrado nenhum pagamento'}}</p>
        </div>
      </div>
      <div v-if="modalPagamento === 2" style="max-height: 300px; overflow: auto">
        <div class="border-bottom p-1 pb-3 d-flex align-items-center justify-content-between">
          <h6 class="pointer text-center mb-0">Logs da Integração</h6>
          <a :href="`https://gestordepedidos.ifood.com.br/#/home/orders/now/${selecionado.ifood_id}`" class="btn btn-primary btn-sm" target="_blank" v-if="selecionado.ifood_id">
            Abrir pedido
          </a>
          <a href="https://www.uairango.com/estabelecimento/0/pedidos" class="btn btn-primary btn-sm" target="_blank" v-if="selecionado.uairango_id">
            Abrir pedido
          </a>
        </div>
        <div class="table-responsive" v-if="logsIntegrador && logsIntegrador.length">
          <table class="table border rounded-sm small my-2">
            <tr class="bg-light">
              <th>Código</th>
              <th>Log</th>
            </tr>
            <tr v-for="l in logsIntegrador">
              <td class="align-middle" style="width: 66px">{{ l.code }}</td>
              <td>
                <div>{{ l.created_at }}</div>
                <div>Status: {{l.status === '1' ? 'Processado' : 'Pendente' }}</div>
              </td>
            </tr>
          </table>
        </div>
        <div class="my-5 text-center" v-else>
          <p class="mb-0">{{loadModal ? 'Carregando dados..' : 'Não foi encontrado nenhum log deste pedido'}}</p>
        </div>
      </div>
      <div class="border-top pt-3 text-center">
        <button class="btn btn-dark rounded-sm" @click="modalPagamento = false">Voltar</button>
      </div>
    </modal>

    <modal :opened="modalImpressao">
      <div class="container-fluid" v-if="selecionado && selecionado.cozinhas">
        <h6 class="font-weight-bold text-center">Qual local você quer imprimir?</h6>
        <div class="my-3">
          <label class="mb-0 d-block mb-3">
            <input type="checkbox" class="mr-1" :value="impressora.device" v-model="cozinhas">
            Caixa (Default)
          </label>
        </div>
        <div class="my-3" v-for="c in selecionado.cozinhas">
          <label class="mb-0 d-block mb-3">
            <input type="checkbox" class="mr-1" :value="c.device" v-model="cozinhas">
            {{ c.nome_cozinha }}
          </label>
        </div>
        <div class="border-top pt-3 text-center d-flex justify-content-between">
          <button class="btn btn-light border p-3 " @click="modalImpressao = false"><i class="fa fa-angle-left"></i> Voltar</button>
          <button class="btn btn-success p-3" @click="imprimir(1, cozinhas)">
            Imprimir
          </button>
        </div>
      </div>
    </modal>

    <modal :opened="modalResumo" no-pad="true">
      <div class="height-100 py-3">
        <resumo-pedidos :empresas="empresas" v-if="modalResumo" :pesquisa="pesquisa"/>
      </div>
      <div class="border-top p-2 text-center d-flex justify-content-between">
        <button class="btn btn-dark border p-3" @click="modalResumo = false"><i class="fa fa-angle-left mr-1"></i> Voltar</button>
        <div>
          <button class="btn btn-primary px-4 py-3" @click="imprimirResumo()">Imprimir <i class="fa fa-print ml-1"></i></button>
        </div>
      </div>
    </modal>

    <modal :opened="modalEntregador" no-pad="true">
      <div v-if="modalEntregador">
        <div class="height-100 pt-3">
          <div class="container-fluid pb-2">
            <h6 class="font-weight-bold mb-3 text-center text-dark">Selecione um entregador</h6>
            <hr>
            <div class="mb-3">
              <input type="search" class="form-control" placeholder="Buscar entregador"
                     @search="pesquisarEntregador(true)"
                     @keydown.esc="voltarModalEntregador"
                     @keyup="pesquisarEntregador()" v-model="termEntregador" id="termEntregador">
            </div>
            <a href="javascript:" class="text-decoration-none list_entregador" :class="{'selected': modalEntregador.id_entregador === e.id_usuario}"
               v-for="(e, index) in entregadores" :id="`entregador${index}`" :key="e.id_usuario" @click="toggleEntregador(e.id_usuario)">
              <div class="px-2 py-3 d-flex justify-content-between align-items-center">
                <div><img src="../../assets/icons/helmet.svg" class="mr-1"> {{ e.nome }}</div>
                <i class="fa fa-check mr-2" v-if="modalEntregador.id_entregador === e.id_usuario"></i>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div class="border-top p-2 text-center d-flex justify-content-between">
        <button class="btn btn-dark border p-3" @click="voltarModalEntregador"><i class="fa fa-angle-left mr-1"></i> Voltar</button>
        <div v-if="modalEntregador">
          <button class="btn btn-primary px-4 p-3" @click="selEntregador()">Salvar</button>
        </div>
      </div>
    </modal>

    <pedido-manual ref="manual" @fechar="atualizarPedidoManual" v-if="!modal"/>
  </div>
</template>

<script>
import MsgHome from "./MsgHome";
import TopBar from '../commons/TopBar.vue'
import Modal from './ModalGestor'
import Loading from "./loading";
import PesquisarPedido from "@/components/gestor/PesquisarPedido";
import ResumoPedidos from "@/components/gestor/ResumoPedidos";
import PedidoManual from "@/components/gestor/PedidoManual";
import CupomDelivery from "@/components/gestor/CupomDelivery";

export default {
  name: 'ContainerPedidos',
  props: ['modal'],
  components: {
    CupomDelivery,
    PedidoManual,
    ResumoPedidos,
    PesquisarPedido,
    Loading,
    MsgHome,
    Modal,
    TopBar
  },

  data() {
    return {
      loadPedidos: false,
      loading: false,
      loadModal: false,
      token: localStorage.getItem('key'),
      pedidos: [],
      pedidosCache: [],
      pesquisa: {
        ativada: false,
        page: 0,
        status: '1',
        origin: '',
        keys: [],
        data: ''
      },
      selecionado: {
        produtos: [],
        tags: [],
        troco: 0,
        total: 0
      },
      modalCancelamento: false,
      modalPagamento: false,
      modalTag: false,
      modalImpressao: false,
      motivos: [],
      entregadores: [],
      modalEntregador: null,
      callbackEntregador: false,
      termEntregador: '',

      cancelamento: {
        tipo_cancelamento: null,
        obs_cancelamento: '',
        requer_observacao: false
      },

      socket: true,

      modalResumo: false,
      cozinhas: [],
      pagamentos: [],
      aberto: false,
      paLoad: 0,
      multiple: false,

      lecardTimeOut: null,
      paTimeOut: null,
      processIfood: false,
      logsIntegrador: [],
      pagination: 10,
      isRead: false,
      ifood: false
    }
  },

  methods: {
    filtrarLocal(pesquisa) {
      if (!pesquisa.data) {
        this.filtrar(pesquisa, true);
        return;
      }

      if (!isNaN(pesquisa.data)) {
        const pedido = this.pedidosCache.find(p => p.id_contador === pesquisa.data);

        if (pedido) {
          this.pedidos = [pedido];
          this.abrirPedido(pedido);

        } else {
          this.filtrar(pesquisa, true);
        }

      } else {
        this.filtrar(pesquisa, true);
      }
    },

    filtrar(pesquisa, force) {
      if (!force && pesquisa.filtro === '1') {
        this.filtrarLocal(pesquisa);

      } else {
        this.clearPedido();
        this.pesquisa = { ...pesquisa, page: 0 };

        this.pedidos = [];
        this.buscarPedidos(!this.pesquisa.ativada);
      }
    },

    clearPesquisa() {
      this.pausarNotificacao();
      this.pesquisa.status = '1';
      this.pesquisa.origin = '';
      this.pesquisa.page = 0;
      this.pesquisa.data = '';
      this.pesquisa.ativada = false;
      this.pedidos = [];
      this.$emit('clearPesquisa');
      this.buscarPedidos(true);
    },

    abrirPedido(p) {
      if (this.pilotoAutomatico && this.paLoad) {
        return;
      }

      this.aberto = true;

      if (this.selecionado.id_pedido !== p.id_pedido) {
        this.buscarPedidoId(p);
      }
    },

    paginarPedidos(count) {
      const page = this.pesquisa.page + count;

      if (page === 0) {
        this.clearPesquisa();

      } else if (page >= 0) {
        this.pedidos = [];
        this.pesquisa.page = page;
        this.pesquisa.ativada = true;
        this.buscarPedidos();
        this.scrollPedido('topo');
        this.togglePilotoAutomatico(false);
      }
    },

    buscarPedidos(play, isonline) {
      if (this.loadPedidos || this.loading || this.paLoad) {
        return;
      }

      this.pesquisa.key = this.token;
      this.pesquisa.isonline = isonline && !this.master;
      this.loadPedidos = true;

      this.$http.get(`v2/pedidos`, { params: this.pesquisa })
        .then(response => {
          this.loadPedidos = false;
          this.loading = false;

          if (!response.data || !response.data.pedidos) {
            return;
          }

          this.pedidos = response.data.pedidos;
          this.pedidosCache = this.pedidos;
          this.pagination = parseInt(response.data.pagination);

          if (this.pedidos.length > 0) {
            const aguardando = this.pedidos.filter(p => p.status === '1').length;

            if (aguardando > 0) {
              if (play) {
                this.tocarNotificacao(aguardando);
              }

              if (this.pilotoAutomatico) {
                this.paLoad = aguardando;
                setTimeout(() => {
                  this.aceitarAutomatico();
                }, 6000);
              }
            }

          } else {
            this.clearPedido();
          }

          this.validarNotificacao();

        }, res => {
          console.log(res);
          this.loading = false;
          this.loadPedidos = false;

          if (res.status === 401) {
            this.logout(true);

          } else if (!navigator.onLine) {
            this.$swal("Não conseguimos acessar sua conexão com a internet. Por favor verifique se seu computador tem uma conexão estável.");
          }
        });
    },

    buscarStatusPedidos() {
      this.$http.get('v2/pedidos/status', {params: this.pesquisa})
        .then(response => {
          if (response && response.data) {
            const pendentes = response.data.pendentes;

            if (pendentes > 0) {
              this.tocarNotificacao(pendentes);

            } else {
              this.pausarNotificacao();
            }
          }

        }, res => {
          console.log(res);
        });
    },

    aceitarAutomatico() {
      if (!this.pilotoAutomatico) {
        this.paLoad = 0;
        clearTimeout(this.paTimeOut);
        return;
      }

      const ps = this.pedidos.filter(p => p.status === '1');
      this.paLoad = ps.length;

      if (ps && ps.length) {
        this.buscarPedidoId(ps[ps.length - 1], (res) => {
          if (res && this.selecionado.status === '1') {
            this.selecionado.receiver = '2';
            this.acaoPedido(2, (res2) => {
              this.paTimeOut = setTimeout(() => {
                if (res2) {
                  this.aceitarAutomatico();

                } else {
                  this.$swal(`Erro ao aceitar automaticamente o pedido: ${this.selecionado.id_pedido}. `);
                  this.paLoad = 0;
                }
              }, 6000);
            });

          } else if (res) {
            this.aceitarAutomatico();

          } else {
            this.paLoad = 0;
          }
        });

      } else {
        this.pausarNotificacao();
        this.buscarPedidos();
      }
    },

    pausarNotificacao() {
      this.$store.commit('setBell', false);
      this.pauseNotification();
    },

    tocarNotificacao(pedidos) {
      const aguardando = pedidos || this.pedidos.filter(p => p.status === '1').length;

      if (aguardando > 0) {
        this.$store.commit('setBell', aguardando);
        this.playNotification();
      }
    },

    buscarPedidoId(dados, callback, scroll) {
      if (this.loading || !dados) {
        return;
      }

      this.cozinhas = [];
      this.selecionado.id_pedido = dados.id_pedido;
      this.loading = true;

      this.$http.get(`delivery/pedidos/${this.token}/${dados.id_pedido}`)
        .then(response => {
          this.loading = false;

          if (!response.data) {
            if (callback) {
              callback(false);
            }

            this.$swal(`Pedido ${dados.id_pedido} não encontrado!`)
            return;
          }

          this.selecionado = response.data;

          this.$nextTick(() => {
            if (callback) {
              callback(true);
            }
          });

          this.statusListaPedidos(this.selecionado, dados, scroll)
          this.validarPedidoSuspeito();
          this.validarNotificacao();

        }, res => {
          console.log(res);
          this.loading = false;

          if (callback) {
            callback(false);
          }

          if (res.status === 401) {
            this.logout(true);

          } else if (!navigator.onLine) {
            this.$swal("Não conseguimos acessar sua conexão com a internet. Por favor verifique se seu computador tem uma conexão estável.");
          }
        });
    },

    statusListaPedidos(selecionado, dados, scroll) {
      const p = this.pedidos.find(p => p.id_pedido === selecionado.id_pedido);

      if (p) {
        p.status = selecionado.status;
        p.is_late = selecionado.is_late || null;
        p.previsao = selecionado.previsao || null;
        p.receiver = selecionado.receiver || '1';
        p.nome_entregador = selecionado.nome_entregador || null;
        p.id_entregador = selecionado.id_entregador || null;
      }

      if (!this.pesquisa.data.trim() && this.pesquisa.status === '1' && selecionado.status === '4') {
        this.pedidos = this.pedidos.filter(p => p.id_pedido !== selecionado.id_pedido);

        if (this.pedidos.length) {
          const p = this.pedidos[scroll ? (this.pedidos.length - 1) : 0];
          this.buscarPedidoId(p);

          if (scroll) {
            this.scrollPedido('listPedido' + p.id_pedido);
          }

        } else if (!dados || !dados.buscaId) {
          this.clearPedido();
        }
      }
    },

    validarPedidoSuspeito() {
      if (this.selecionado.suspeito === '1' && !this.pilotoAutomatico && this.selecionado.status === '1') {
        this.$swal({
          icon: 'warning',
          title: "Cliente Bloqueado",
          text: "Você marcou o cliente deste pedido como bloqueado, recomendamos uma revisão.",
          buttons: "Ok",
        });
      }
    },

    clearPedido(clearUrl) {
      this.aberto = false;
      this.pesquisa.page = 0;
      this.selecionado = {
        tags: [],
        produtos: [],
        troco: 0,
        total: 0
      };

      if (clearUrl) {
        this.buscarPedidos();
      }
    },

    scrollPedido(element) {
      const el = document.getElementById(element);
      if (el) el.scrollIntoView(false);
    },

    acaoPedido(status, callback) {
      if (this.loading) {
        return;
      }

      let dados = {
        status: status,
        id_pedido: this.selecionado.id_pedido,
        ifood_id: this.selecionado.ifood_id || null,
        uairango_id: this.selecionado.uairango_id || null,
        origin: this.selecionado.origin ? this.selecionado.origin.toString() : '',
        receiver: this.selecionado.receiver || '1',
        tipo_cancelamento: this.cancelamento.tipo_cancelamento,
        obs_cancelamento: this.cancelamento.obs_cancelamento,
        empresa: this.selecionado.token
      };

      if (status === 2) {
        this.pausarNotificacao();
      }

      this.modalCancelamento = false;
      this.loading = true;

      this.$http.post('delivery/pedidos/' + this.token, dados)
        .then(res => {
          this.loading = false;
          this.cancelamento.tipo_cancelamento = null;
          this.cancelamento.obs_cancelamento = '';
          this.cancelamento.requer_observacao = false;
          const data = res.data;

          if (data.success) {
            if (status === 2) {
              this.buscarPedidoId(this.selecionado, (res) => {
                if (res) {
                  if (this.impressora.automatico === '1' || this.pilotoAutomatico) {
                    this.imprimir(this.impressora.nCopias || 1);
                  }
                }

                if (callback) {
                  callback(res);
                }
              });

            } else if (!this.selecionado.ifood_id || status !== 5) {
              this.selecionado.status = status + '';
              this.selecionado.obs_cancelamento = dados.obs_cancelamento;
              this.statusListaPedidos(this.selecionado);
            }

            if (!this.selecionado.ifood_id || status !== 5) {
              this.$socket.emit('notification', {
                token: dados.empresa,
                play: false,
                id_pedido: dados.id_pedido,
                status: dados.status + '',
                session: this.$store.state.session,
                obs_cancelamento: dados.obs_cancelamento
              });
            }

            if (dados.ifood_id) {
              if (status === 5) {
                this.$swal("A solicitação de cancelamento foi enviada, por favor aguarde no status do pedido.");
              }

            } else {
              if (status === 5) {
                this.$swal("Cancelamento realizado com sucesso!");
              }

            }

          } else {
            this.$swal(res.data.msg ? res.data.msg : "Tente novamente");
          }

          if (callback && status !== 2) {
            callback(false);
          }

        }, res => {
          this.loading = false;
          const data = res.data;          

          if (callback) {
            callback(false);
          }

          if(data && data.msg && dados.origin == 7){
            this.$swal("Pedido UaiRango: " + data.msg);
          }

          if (data && data.status == 1) {
            this.$swal(data.msg).then(() => {
              this.buscarPedidos(false);
            });
          }

          if (res.status === 401) {
            window.location.reload(true);
          }
        });
    },

    prepararImpressao() {
      if (!this.selecionado.id_pedido || this.paLoad) {
        return;
      }

      if (this.selecionado.cozinhas && this.selecionado.cozinhas.length) {
        this.cozinhas = [this.impressora.device];
        this.modalImpressao = true;

      } else {
        this.imprimir(1);
      }
    },

    imprimir(ncopias, cozinhas) {
      if (!this.selecionado.id_pedido) {
        return;
      }

      if (this.isElectron || !this.impressora.mobilePrint) {
        const html = document.getElementById('containerPedido');

        if (!html) {
          return;
        }

        let detail = {
          copies: ncopias,
          content: html.innerHTML,
          status: 1,
          nome_documento: `Pedido ${this.selecionado.id_pedido}`,
          device: this.impressora.device || null,
          impressora: this.impressora
        };

        if (cozinhas || this.selecionado.cozinhas) {
          const devices = cozinhas ? cozinhas : this.selecionado.cozinhas.map(c => { return c.device });
          this.modalImpressao = false;
          let dataPrint = [];

          for (let i = 0; i < devices.length; i++) {
            dataPrint.push({
              copies: 1,
              content: html.innerHTML,
              status: 1,
              nome_documento: `Pedido ${this.selecionado.id_pedido}`,
              device: devices[i],
              id_pedido: this.selecionado.id_pedido,
              impressora: {
                device: devices[i],
                devicePdv: this.impressora.devicePdv,
                largura: this.impressora.largura,
                zoom: this.impressora.zoom
              }
            });
          }

          this.$helpers.imprimir(this, this.selecionado.token, dataPrint, false);

          if (!cozinhas) {
            detail.copies = 1;
            detail.impressora = this.impressora;
            detail.device = this.impressora.device || null;

            if (localStorage.getItem('printCashier')) {
              this.$helpers.imprimir(this, this.selecionado.token, [detail], false);
            }
          }

        } else {
          this.$helpers.imprimir(this, this.selecionado.token, [detail]);
        }

      } else {
        const id = this.selecionado.token + "/" + this.selecionado.cliente.id_cliente + "/" + this.selecionado.id_pedido;
        const par = `?imprimir=true&ncopias=${ncopias}&zoom=${this.impressora.zoom}&largura=${this.impressora.largura}`;
        const url = this.base_server + "public/order/" + id + par;
        this.imprimirExterno(url);
      }
    },

    visualizarResumo() {
      this.$helpers.confirmarSenhaAdm(this, () => {
        this.modalResumo = true;
      });
    },

    imprimirResumo() {
      const html = document.getElementById('resumoDiario');

      if (!html) {
        return;
      }

      const cf = this.$store.state.impressora;
      const device = cf.devicePdv || null;
      const dataImpressao = {
        content: html.innerHTML,
        copies: 1,
        isPdv: true,
        status: 1,
        nome_documento: 'Resumo diário',
        device,
        impressora: {
          device,
          zoom: cf.zoom || "9px",
          largura: cf.largura || '100%'
        }
      };

      this.$helpers.imprimirComprovante(this, localStorage.getItem('token'), [dataImpressao], cf.mobilePrint);
    },

    imprimirExterno(url) {
      const y = window.top.outerHeight / 2 + window.top.screenY - ( 1000 / 2);
      const x = window.top.outerWidth / 2 + window.top.screenX - ( 1000 / 2);
      const myWindow = window.open(url, "", `toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=600, height=600, top=${y}, left=${x}`);

      if (myWindow) {
        myWindow.focus();
      }
    },

    openModalCancelamento() {
      this.modalCancelamento = true;
      this.cancelamento.tipo_cancelamento = null;
      this.cancelamento.obs_cancelamento = '';
      this.cancelamento.requer_observacao = false;
      this.pausarNotificacao();

      if (this.loadModal) {
        return;
      }

      this.loadModal = true;
      this.$http.get('v2/pedidos/motivos-cancelamento', {
        params: { id_pedido: this.selecionado.id_pedido },
        headers: { authentication: this.token }
      }).then(response => {
        this.loadModal = false;
        this.motivos = response.data || [];

        if (!this.motivos.length) {
          this.modalCancelamento = false;
          this.$swal("Não há motivos de cancelamento disponíveis para este pedido.");
        }
      }, res => {
        this.loadModal = false;
        this.modalCancelamento = false;
        this.$swal(res.data && (res.data.message || res.data.msg) || "Não foi possível buscar os motivos de cancelamento.");
      });
    },

    changeCancelamento() {
      const motivo = this.motivos.find(m => m.tipo_cancelamento === this.cancelamento.tipo_cancelamento);
      this.cancelamento.requer_observacao = motivo ? motivo.requer_observacao : false;
      this.cancelamento.obs_cancelamento = motivo && !motivo.requer_observacao ? motivo.obs_cancelamento : '';

      if (this.cancelamento.requer_observacao) {
        setTimeout(() => {
          document.getElementById("textCancelamento").focus();
        }, 200);
      }
    },

    cancelarPedido() {
      const motivo = this.motivos.find(m => m.tipo_cancelamento === this.cancelamento.tipo_cancelamento);
      if (!this.cancelamento.obs_cancelamento.trim() && motivo && !motivo.requer_observacao) {
        this.cancelamento.obs_cancelamento = motivo.obs_cancelamento;
      }

      this.$helpers.confirmarSenhaAdm(this, () => {
        this.acaoPedido(5);
      });
    },

    openModalPagamento() {
      if (this.loadModal) {
        return;
      }

      this.loadModal = true;
      this.pagamentos = [];
      this.modalPagamento = 1;

      this.$http.get('pagamentos/' + this.token + '/' + this.selecionado.id_pedido)
        .then(response => {
          this.loadModal = false;

          if (response.data && response.data.length) {
            this.pagamentos = response.data;
          }

        }, res => {
          console.log(res);
          this.loadModal = false;
          this.$swal(res.data.msg);
        });
    },

    openModalIntegracao() {
      if (this.loadModal) {
        return;
      }

      this.loadModal = true;
      this.logsIntegrador = [];
      this.modalPagamento = 2;
      const order_id = this.selecionado.ifood_id ? this.selecionado.ifood_id : this.selecionado.uairango_id;

      this.$http.get('integrador/logs/' + this.token, { params: { order_id } })
        .then(response => {
          this.loadModal = false;

          if (response.data && response.data.length) {
            this.logsIntegrador = response.data;
          }

        }, res => {
          console.log(res);
          this.loadModal = false;
          this.$swal(res.data.msg);
        });
    },

    toggleCliente() {
      const bloqueado = !!this.selecionado.tags.find(tag => tag.id_tag === '2');
      const text = !bloqueado ?
          "Deseja bloquear este cliente?\nEle não poderá realizar novos pedidos pelo LeCard e em outros locais a impressão será marcada como suspeita."
          : "Deseja desbloquear este cliente?\nEle voltará a realizar pedidos pelo LeCard.";
      this.$swal({
        text,
        buttons: ["Não", "Sim"],
        dangerMode: true
      }).then(res => {
        if (res) {
          this.selecionado.suspeito = !bloqueado ? '1' : '0';

          if (!bloqueado) {
            this.selecionado.tags.push({ id_tag: '2', nome_tag: 'Bloqueado', color: 'danger' })

          } else {
            this.selecionado.tags = []
          }

          const dados = { id_cliente: this.selecionado.id_cliente, tags: this.selecionado.tags };

          this.$http.post('clientes/tags/' + this.token, dados).then(res => {}, res => {
            this.$swal(res.data.msg);
          });
        }
      });
    },

    loopPedidos() {
      clearTimeout(this.lecardTimeOut);

      if (this.isRead) {
        return;
      }

      this.lecardTimeOut = setTimeout(() => {
        if (!this.$socket.connected) {
          window.location.reload();

        } else if (!this.paLoad || !this.pesquisa.ativada) {
          this.buscarPedidos(true, true);
        }

        this.loopPedidos();
      }, (1000 * 60 * 4));
    },

    validarNotificacao() {
      if (!this.pesquisa.ativada && !this.pedidos.find(p => p.status === '1')) {
        this.pausarNotificacao();
      }
    },

    reprocessarFilaIfood() {
      if (localStorage.getItem('token')) {
        this.$http.post('integrador/ifood/fila',{ token: localStorage.getItem('token') });
      }
    },

    atualizarPedidoManual(pedido) {
      this.$store.state.load = false;

      this.buscarPedidoId(pedido, (res) => {
        if (res) {
          this.$swal("Pedido realizado com sucesso!");

          if (this.impressora.automatico === '1') {
            this.imprimir(this.impressora.nCopias);
          }

          this.buscarPedidos(false);
        }
      });
    },

    pesquisarEntregador(selecionar) {
      if (this.termEntregador.trim().length) {
        this.entregadores = this.user.entregadores.filter(e => {
          return e.nome.toLowerCase().indexOf(this.termEntregador.toLowerCase()) !== -1;
        });

        if (selecionar && this.entregadores.length === 1) {
          this.selEntregador(this.entregadores[0]);
        }

      } else {
        this.entregadores = this.user.entregadores;
      }
    },

    escolherEntregador(pedido, despachar) {
      if (pedido.tipo_pedido !== '1' || !this.user.entregadores || (despachar && pedido.id_entregador)) {
        this.acaoPedido(3);
        return;
      }

      if (despachar) {
        this.callbackEntregador = true;
      }

      this.termEntregador = '';
      this.entregadores = this.user.entregadores;
      this.modalEntregador = { id_pedido: pedido.id_pedido, id_entregador: pedido.id_entregador, nome_entregador: pedido.nome_entregador, editar: !!pedido.id_entregador };
      this.$nextTick(() => {
        this.$helpers.focusElement('termEntregador');
      });
    },

    toggleEntregador(id) {
      this.modalEntregador.id_entregador = this.modalEntregador.id_entregador === id ? null : id;

      if (id && !this.modalEntregador.editar) {
        this.selEntregador();
      }
    },

    selEntregador() {
      let dados = {
        id_pedido: this.modalEntregador.id_pedido,
        id_entregador: this.modalEntregador.id_entregador || null
      };

      this.$store.state.load = "Selecionando entregador";
      this.modalEntregador = null;

      this.$http.post("delivery/pedidos/entregador/" + this.token, dados)
        .then(res => {
          this.$store.state.load = false;

          if (!res.data.success) {
            this.callbackEntregador = false;
            this.$swal(response.data.msg || "Erro ao vincular entregador!");
            return;
          }

          if (this.callbackEntregador) {
            this.callbackEntregador = false;
            this.acaoPedido(3, () => {
              this.buscarPedidoId(this.selecionado);
            });

            return;

          } else if (this.selecionado.id_pedido === dados.id_pedido) {
            this.buscarPedidoId(this.selecionado);
          }

          this.buscarPedidos(false);

        }, res => {
          console.log(res);
          this.loading = false;
          this.callbackEntregador = false;
        });
    },

    voltarModalEntregador() {
      this.callbackEntregador = false;
      this.modalEntregador = false;
    },

    togglePilotoAutomatico(status) {
      if (this.loading || this.loadPedidos) {
        return;
      }

      if (!this.pilotoAutomatico && this.pesquisa.ativada) {
        this.$swal("Utilize o módulo kanban para filtrar pedidos com o piloto automático ativado.");
        return;
      }

      if (status && !this.pilotoAutomatico && this.printServer) {
        this.$swal({
          text: "Atenção, você ainda precisará ficar atento se sua impressora está funcionando para imprimir os pedidos.",
          buttons: ["Cancelar", "Ativar"],
          dangerMode: true
        }).then(res => {
          if (res) {
            localStorage.setItem('pilotoAutomatico', '1');
            this.$store.state.pilotoAutomatico = true;
            this.clearPesquisa();
          }
        });

      } else {
        localStorage.setItem('pilotoAutomatico', '0');
        this.$store.state.pilotoAutomatico = false;
      }
    },

    msgIfood() {
      this.$swal("Certifique-se de que o Gestor Principal esteja sempre aberto para garantir que os pedidos do iFood sejam sincronizados.");
    },
  },

  mounted() {
    this.multiple = this.empresas.length > 1;

    this.isRead = this.$store.state.is_comanda || this.$store.state.isReadOnly;

    if (!this.isRead) {
      this.buscarPedidos(true, true);
      this.loopPedidos();
    }

    this.ifood = !!(this.integracoes.find(i => i.plataforma === '2' && i.fg_ativo === '1'));
  },

  created() {
    this.$parent.$on("closePedido", () => {
      if (this.aberto) {
        this.clearPedido(true);
      }
    });

    this.$parent.$on("clearPedidos", () => {
      this.clearPesquisa();
    });

    this.$parent.$on("abrirPedidos", () => {
      if (this.isRead) {
        this.buscarPedidos(false);
      }
    });
  },

  beforeDestroy() {
    clearTimeout(this.lecardTimeOut);
    clearTimeout(this.paTimeOut)
  },

  computed: {
    podeConfirmarCancelamento() {
      if (!this.cancelamento.tipo_cancelamento) {
        return false;
      }

      return !this.cancelamento.requer_observacao || this.cancelamento.obs_cancelamento.trim().length > 0;
    },

    empresas() {
      return this.$store.state.empresas
    },

    user() {
      return this.$store.state.dataUser
    },

    canPlay() {
      return this.$store.state.canPlay
    },

    master() {
      return this.$store.state.dataUser.master
    },

    impressora() {
      return this.$store.state.impressora
    },

    pilotoAutomatico() {
      return this.$store.state.pilotoAutomatico
    },

    printServer() {
      return this.$store.state.printServer
    },

    bell() {
      return this.$store.state.bell
    },

    integracoes() {
      return this.$store.state.integracoes
    },

    ifoodAtivo() {
      return this.$store.state.ifoodAtivo
    }
  },

  watch: {
    canPlay(val) {
      if (val) {
        this.tocarNotificacao();
      }
    }
  },

  sockets: {
    connect() {
      const buscar = !this.isRead && this.token && this.$store.state.isReady && !this.is_mobile;
      if (buscar) {
        this.buscarPedidos(true);
      }
    },

    delivery_order() {
      if (this.isRead) {
        return;
      }

      if (this.pesquisa.ativada) {
        this.buscarStatusPedidos();

      } else if (!this.paLoad) {
        this.buscarPedidos(true);
      }
    },

    notification(data) {
      if (this.isRead) {
        return;
      }

      if (data && data.session && data.id_pedido && data.status && (data.session !== this.$store.state.session)) {
        if (data.id_pedido === this.selecionado.id_pedido) {
          this.selecionado.status = data.status;
          this.selecionado.obs_cancelamento = data.obs_cancelamento || null;
        }

        this.statusListaPedidos(data);

        if (data.session === "integrador-ifood" && data.status === '5') {
          this.$swal({
            title: 'Atenção!',
            text: 'Um pedido do iFood foi cancelado!\nMotivo: ' + (data.obs_cancelamento || ""),
            buttons: ['Voltar', 'Ver Pedido']
          }).then((r) => {
            if (r) {
              this.abrirPedido({ id_pedido: data.id_pedido, token: data.token });
            }
          });
        }

        this.validarNotificacao();
      }
    }
  },

  filters: {
    valor(value) {
      const formatter = new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL', minimumFractionDigits: 2});
      return value ? formatter.format(parseFloat(value)) : 'R$ 0,00';
    },

    status(s) {      
      switch (s) {
        case "1":
          return "Pendente";
        case "2":
          return "Pago";
        case "5":
          return "Reembolsado";
        default:
          return s;
      }
    }
  }
}
</script>

<style scoped>
.border {
  border-radius: 4px;
}

.list_entregador {
  display: block;
  margin-bottom: 8px;
  color: var(--dark);
  border: 1px solid #dee2e6;
  border-radius: 4px;
}

.list_entregador.selected {
  border: 1px solid var(--primary);
  color: var(--primary);
}

.list-pedido-footer {
  font-weight: bold;
  font-size: 0.8rem;
  border: 1px solid #E9ECEF;
  text-align: center;
  padding: 0 12px;
  border-radius: 12px;
  margin-top: 6px;
}
</style>
